import { OnlyIElementsStore } from "@/store/ielements-slice-selector";
import {
  IElement,
  IElementImgSheetTiled,
  IElementSection,
  IElementType,
  IElementTypeHint,
  isIElementAttachmentsGroup,
  isIElementImgSheetTiled,
  isIElementRoomSection,
  isIElementTimeSeriesRoom,
  WithHint,
} from "@faro-lotv/ielement-types";
import { selectChildDepthFirst } from "@faro-lotv/project-source";

/**
 * Check if given IElement is a location marker holder
 *
 * @param element the given element to check
 * @param state current store state
 * @returns true if the given element is a room section with empty time series child element
 */
export function isLocationMarker(
  element: IElement,
  state: OnlyIElementsStore,
): boolean {
  if (!isIElementRoomSection(element)) return false;

  const timeSeriesRoom = selectChildDepthFirst(
    element,
    isIElementTimeSeriesRoom,
  )(state);

  const photoGroup = selectChildDepthFirst(
    element,
    isIElementAttachmentsGroup,
  )(state);

  // room section with empty time series room and empty photo group is a location marker
  return (
    !!timeSeriesRoom &&
    !timeSeriesRoom.childrenIds?.length &&
    !photoGroup?.childrenIds?.length
  );
}

export type IElementPhotogrammetryScan = WithHint<
  IElementSection,
  IElementTypeHint.photogrammetryScan
>;

/**
 * @returns True if the input element is a photogrammetry scan
 * @param e The element to check
 */
export function isIElementPhotogrammetryScan(
  e: IElement,
): e is IElementPhotogrammetryScan {
  return (
    e.type === IElementType.section &&
    e.typeHint === IElementTypeHint.photogrammetryScan
  );
}

/** Here a new type is defined for orthomosaic images from photogrammetry datasets. */
export type IElementOrthomosaic = IElementImgSheetTiled;

/**
 * Here a new discriminator is defined for orthomosaic images,
 * in the future it may be different from isIElementImgSheetTiled if orthomosaics have a specific type hint.
 */
export const isIElementOrthomosaic = isIElementImgSheetTiled;
